import { extensions } from '../../extensions/Extensions.mjs';
import { MeshPipe } from './shared/MeshPipe.mjs';

"use strict";
extensions.add(MeshPipe);
//# sourceMappingURL=init.mjs.map
